import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaXTwitter } from "react-icons/fa6"; 

export default function FounderIntroSection({
  title,
  highlight1,
  highlight2,
  description,
  quote,
  signature,
  buttonText,
  buttonLink,
  mainImage,
  mainImageAlt,
  overlayTitle,
  socialLinks,
  overlayBgColor = "#ffffff",
}) {
  return (
    <section className="py-16 bg-[#FDFBF9] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center gap-12">
        {/* LEFT SIDE */}
        <div className="md:w-1/2">
          <h2 className="text-4xl sm:text-5xl font-semibold text-gray-900 leading-snug mb-5">
            {title.split(highlight1)[0]}
            <span className="text-[#C03CA0] font-bold">{highlight1}</span>, the{" "}
            <span className="text-[#C03CA0] font-bold">{highlight2}</span> Behind the Brand
          </h2>

          <p className="text-gray-700 mb-4 leading-relaxed">{description}</p>

          <p className="text-gray-900 text-lg font-medium italic">
            “{quote}”
          </p>
          <img
            src={signature}
            alt="Nafsika Antypas signature"
            width={101}
            height={56}
            loading="lazy"
            decoding="async"
            className="block ml-3 h-14 align-middle mb-4"
          />

          <a
            href={buttonLink}
            target="_blank"
            rel="noreferrer"
            className="inline-block bg-white border border-gray-300 text-gray-900 px-6 py-3 rounded-full font-semibold hover:bg-gray-50 transition"
          >
            {buttonText}
          </a>
        </div>

        {/* RIGHT SIDE */}
        <div className="md:w-1/2 relative">
          {/* MAIN IMAGE */}
          <img
            src={mainImage}
            alt={mainImageAlt}
            loading="lazy"
            decoding="async"
            className="rounded-2xl w-full object-cover"
          />

          {/* FLOATING SOCIAL CARD */}
          <div
            className="absolute bottom-[-30px] left-1/2 -translate-x-1/2 md:left-[10%] md:bottom-[20px] bg-white rounded-xl shadow-xl p-4 flex flex-col items-center text-center w-[250px] animate-float"
            style={{ backgroundColor: overlayBgColor }}
          >
            <p className="font-semibold text-gray-800 mb-3">{overlayTitle}</p>
            <div className="flex items-center justify-center gap-4">
              {/* {socialLinks?.facebook && (
                <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                  <FaFacebookF />
                </a>
              )}
              {socialLinks?.x && (
                <a href={socialLinks.x} target="_blank" rel="noopener noreferrer" className="social-icon twitter">
                  <FaXTwitter />
                </a>
              )}
              {socialLinks?.instagram && (
                <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                  <FaInstagram />
                </a>
              )}
              {socialLinks?.linkedin && (
                <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
                  <FaLinkedinIn />
                </a>
              )} */}
               {socialLinks.map(({ href, Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  className="text-gray-700 hover:text-[#C03CA0] text-xl"
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      
    </section>
  );
}
